import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const RETRIEVED_CLIENT = "RETRIEVED_CLIENT";
export const RETRIEVED_CLIENTS = "RETRIEVED_CLIENTS";
export const SAVED_CLIENT = "SAVED_CLIENT";
export const SAVING_CLIENT = "SAVING_CLIENT";
export const CLEAR_SAVED_CLIENT = "CLEAR_SAVED_CLIENT";
export const RETRIEVED_CLIENT_TYPES = "RETRIEVED_CLIENT_TYPES";

const savingClient = (saving) => {
  return {
    type: SAVING_CLIENT,
    saving: saving,
  };
};

export const clearSavedClient = () => {
  return {
    type: CLEAR_SAVED_CLIENT,
  };
};

export const getClient = (client_id) => {
  return (dispatch) => {
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/client/${client_id}`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === false && data.logged_in === false) {
          return;
        }

        console.log("!!! CLIENT DATA: ", data.client);

        dispatch({
          type: RETRIEVED_CLIENT,
          client: data.client,
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };
};

export const getClients = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/client`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === false && data.logged_in === false) {
          return;
        }

        dispatch({
          type: RETRIEVED_CLIENTS,
          clients: data,
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };
};

export const saveClient = (client) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    dispatch(savingClient(true));
    console.log("SAVE CLIENT: ", client);
    const method = client.id ? "PUT" : "POST";
    const url = client.id
      ? `${config.REST_SERVER_URL}/admin/client/${client.public_id}`
      : `${config.REST_SERVER_URL}/admin/client`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify(client),
    })
      .then((response) => response.json())
      .then((client) => {
        dispatch({
          type: SAVED_CLIENT,
          savedClient: client,
        });

        // For now, just reload the clients
        dispatch(getClients());
      })
      .catch((error) =>
        /* TODO: dispatch error */
        console.log("ERROR: ", error)
      )
      .finally(() => {
        dispatch(savingClient(false));
      });
  };
};
